import { render, staticRenderFns } from "./FormSubmitPackages.vue?vue&type=template&id=e52e47e4&"
import script from "./FormSubmitPackages.vue?vue&type=script&lang=js&"
export * from "./FormSubmitPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports